import script from "./VoicePlayground.vue?vue&type=script&setup=true&lang=js"
export * from "./VoicePlayground.vue?vue&type=script&setup=true&lang=js"

import "./VoicePlayground.vue?vue&type=style&index=0&id=22edf08d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22edf08d"]])

export default __exports__